// Shared retry helper for photo add / merge uploads.
// Permanent rejections (400 max-photos, 409 duplicate) are NOT retried.

export const isPermanentUploadError = (err) => {
  const s = err?.response?.status;
  return s === 400 || s === 409;
};

export const isNetworkError = (err) => {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return true;
  return err?.code === 'ERR_NETWORK' || err?.message === 'Network Error' || !err?.response;
};

const DEFAULT_DELAYS = [600, 1500, 3000];

// Runs `fn` with automatic backoff on transient failures.
// onAttempt(nextAttempt, total) fires before each wait so the UI can show
// a "Retrying…" indicator. Throws the last error once attempts are exhausted
// (or immediately for permanent errors).
export async function withRetry(fn, { retries = 3, delays = DEFAULT_DELAYS, onAttempt } = {}) {
  let lastErr;
  for (let i = 0; i < retries; i++) {
    try {
      return await fn();
    } catch (err) {
      lastErr = err;
      if (isPermanentUploadError(err) || err?.__queued) throw err;
      if (i < retries - 1) {
        if (onAttempt) onAttempt(i + 2, retries);
        await new Promise((r) => setTimeout(r, delays[i] ?? DEFAULT_DELAYS[DEFAULT_DELAYS.length - 1]));
      }
    }
  }
  throw lastErr;
}
